module.exports = __webpack_public_path__ + "static/media/telehealth-news.62a3d1a7.jpg";